function UhOhMessageDirective(supportService) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      message: '@',
      reason: '@',
      supportMessage: '@',
      type: '@',
      action1: '='
    },
    template: `<div class="uh-oh-message">
      <div class="uh-oh-message-alert alert animated fadeInUp" ng-class="{ 'alert-info' : type === 'info', 'alert-warning' : type === 'warning', 'alert-danger' : type === 'danger' }">
        <i class="uh-oh-message-alert-icon fa fa-exclamation-triangle"></i> <h3>{{ message }}</h3>
      </div>
      <div class="uh-oh-message-support">
        <p ng-transclude></p>
      </div>
    </div>`,
    link: function (scope, element, attrs, ctrl, transcludeFn) {
      scope.type = scope.type || 'warning';

      //http://angular-tips.com/blog/2014/03/transclusion-and-scopes/
      //transclude so the inner html's scope is the directive controllers, and not a new scope
      transcludeFn(scope, function (clone) {
        const contentElement = element[0].querySelector('[ng-transclude]');

        contentElement.innerHTML = '';

        for (let i = 0; i < clone.length; ++i) { //eslint-disable-line
          contentElement.appendChild(clone[i]);
        }
      });
    },
    controller: [
      '$scope',
      ($scope) => {
        $scope.openSupport = function ($event) {
          if ($event) $event.preventDefault();

          if ($scope.reason) {
            supportService.showNewMessage($scope.reason);
          } else {
            supportService.showNewMessage();
          }
        };
      }
    ]
  };
}

UhOhMessageDirective.$inject = [
  'supportService'
];

export default UhOhMessageDirective;



// WEBPACK FOOTER //
// ./src/directives/uhOhMessage.js